import calculateAge from '../../lib/calculateAge';

export default class BasicApplication {
  init() {
    const $basicForm = $('.basic-form');

    if ($basicForm.length > 0) {
      this.formListeners($basicForm);
    }

    this.setupFederalWithholdings();
    this.verifyCustomWithholdingsDownloaded();
  }

  setupFederalWithholdings() {
    const exemptStatus = 'true';
    const $exemptContinueButton = $('.exempt-continue-button');
    const $toggleExemptSelector = $('[data-toggle-exempt]');
    const $toggleExemptSelectorTwo = $('[data-toggle-exempt-two]');
    const $exemptSelect = $('[data-filing-status-exempt="exempt"]');

    if ($exemptSelect.find(':selected').val() === exemptStatus) {
      $toggleExemptSelector.addClass('disabled');
      $toggleExemptSelector.find(':input').val('');
      $toggleExemptSelector.find(':input').attr('disabled', true);
      $toggleExemptSelectorTwo.hide();
    } else {
      $exemptContinueButton.hide();
    }

    $exemptSelect.change(function () {
      if ($(this).val() === exemptStatus) {
        $toggleExemptSelector.addClass('disabled');
        $toggleExemptSelector.find(':input').val('');
        $toggleExemptSelector.find(':input').attr('disabled', true);
        $toggleExemptSelectorTwo.hide();
        $exemptContinueButton.show();
      } else {
        $toggleExemptSelector.removeClass('disabled');
        $toggleExemptSelector.find(':input').attr('disabled', false);
        $toggleExemptSelectorTwo.show();
        $exemptContinueButton.hide();
      }
    });
  }

  verifyCustomWithholdingsDownloaded() {
    const $continueButton = $('#submit-button');
    const $downloadCheckbox = $('[data-status="downloaded"]');

    if ($downloadCheckbox.length) {
      $continueButton.prop('disabled', true);

      if ($downloadCheckbox.is(':checked')) {
        $continueButton.prop('disabled', false);
      }

      $downloadCheckbox.change(function () {
        if (this.checked) {
          $continueButton.prop('disabled', false);
        } else {
          $continueButton.prop('disabled', true);
        }
      });
    }
  }

  formListeners($form) {
    const $dateOfBirth = $form.find('#person_date_of_birth');
    const $smoker = $form.find('.person_smoker');

    $dateOfBirth.change(() => this.onAgeChange($dateOfBirth.val(), $smoker)).change();
  }

  onAgeChange(dateOfBirth, $smoker) {
    const personAge = calculateAge(dateOfBirth);
    const $smokerCheckbox = $smoker.find('#person_smoker');

    if (personAge < gon.minimal_tobacco_age) {
      $smokerCheckbox.prop('checked', false);
      $smoker.hide();
    } else {
      $smoker.show();
    }
  }
}
